import axiosClient from 'apis/axios-client';
import { AxiosResponse } from 'axios';

const GET_USERS_URL = '/AdminUser/GetUsers';
const UPDATE_USER_STATUS_URL = '/AdminUser/UpdateUserStatus';

export const getUsers = async (
  searchTerm: string,
  filter: string,
  page: number,
  size: number
): Promise<any> => {
  try {
    const url = `${GET_USERS_URL}?searchTerm=${encodeURIComponent(searchTerm)}&filter=${encodeURIComponent(filter)}&page=${page}&size=${size}`;

    const response: AxiosResponse<any> = await axiosClient.get(url);
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching users:', error.message);
    } else {
      console.error('Unknown error fetching users');
    }
    throw error;
  }
};


export const updateUserStatus = async (
  userId: number,
  isBlocked: boolean,
  comment: string
): Promise<any> => {
  try {
    const payload = {
      userId,
      isBlocked,
      comment,
    };

    const response: AxiosResponse<any> = await axiosClient.post(
      UPDATE_USER_STATUS_URL,
      payload
    );

    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error updating user status:', error.message);
    } else {
      console.error('Unknown error updating user status');
    }
    throw error;
  }
};
